"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var article_collection_1 = require("./components/article_collection");
var brand_collection_1 = require("./components/brand_collection");
var call_to_action_1 = require("./components/call_to_action");
var category_collection_1 = require("./components/category_collection");
var category_search_1 = require("./components/category_search");
var cms_page_cards_1 = require("./components/cms_page_cards");
var csp_collection_1 = require("./components/csp_collection");
var csp_feature_1 = require("./components/csp_feature");
var curated_set_collection_1 = require("./components/curated_set_collection");
var full_bleed_heading_1 = require("./components/full_bleed_heading");
var heading_1 = require("./components/heading");
var image_embed_1 = require("./components/image_embed");
var image_gallery_1 = require("./components/image_gallery");
var image_feature_1 = require("./components/image_feature");
var link_list_1 = require("./components/link_list");
var cms_listings_collection_1 = require("./components/cms_listings_collection");
var markdown_section_html_1 = require("./components/markdown_section_html");
var marketing_callout_1 = require("./components/marketing_callout");
var pullquote_1 = require("./components/pullquote");
var review_list_1 = require("./components/review_list");
var seo_blurb_1 = require("./components/seo_blurb");
var recently_viewed_listings_1 = require("./components/recently_viewed_listings");
var subcategory_nav_1 = require("./components/subcategory_nav");
var video_embed_1 = require("./components/video_embed");
var COMPONENT_TYPES = require("./component_types");
exports.COMPONENT_OUTPUT = Object.freeze((_a = {},
    _a[COMPONENT_TYPES.ARTICLE_SECTION] = article_collection_1.default,
    _a[COMPONENT_TYPES.BRAND_COLLECTION] = brand_collection_1.default,
    _a[COMPONENT_TYPES.CALL_TO_ACTION] = call_to_action_1.default,
    _a[COMPONENT_TYPES.CATEGORY_COLLECTION] = category_collection_1.default,
    _a[COMPONENT_TYPES.CATEGORY_SEARCH] = category_search_1.default,
    _a[COMPONENT_TYPES.CMS_PAGE_CARDS] = cms_page_cards_1.default,
    _a[COMPONENT_TYPES.CSP_COLLECTION] = csp_collection_1.default,
    _a[COMPONENT_TYPES.CSP_FEATURE] = csp_feature_1.default,
    _a[COMPONENT_TYPES.CURATED_SET_COLLECTION] = curated_set_collection_1.default,
    _a[COMPONENT_TYPES.FULL_BLEED_HEADING] = full_bleed_heading_1.default,
    _a[COMPONENT_TYPES.HEADING] = heading_1.default,
    _a[COMPONENT_TYPES.IMAGE_EMBED] = image_embed_1.default,
    _a[COMPONENT_TYPES.IMAGE_FEATURE] = image_feature_1.default,
    _a[COMPONENT_TYPES.IMAGE_GALLERY] = image_gallery_1.default,
    _a[COMPONENT_TYPES.LINK_LIST] = link_list_1.default,
    _a[COMPONENT_TYPES.LISTINGS_COLLECTION] = cms_listings_collection_1.default,
    _a[COMPONENT_TYPES.MARKDOWN_TO_HTML_SECTION] = markdown_section_html_1.default,
    _a[COMPONENT_TYPES.MARKETING_CALLOUT] = marketing_callout_1.default,
    _a[COMPONENT_TYPES.PULLQUOTE] = pullquote_1.default,
    _a[COMPONENT_TYPES.RECENTLY_VIEWED_LISTINGS] = recently_viewed_listings_1.default,
    _a[COMPONENT_TYPES.REVIEW_LIST] = review_list_1.default,
    _a[COMPONENT_TYPES.SEO_BLURB] = seo_blurb_1.default,
    _a[COMPONENT_TYPES.SUBCATEGORY_NAV] = subcategory_nav_1.default,
    _a[COMPONENT_TYPES.VIDEO_EMBED] = video_embed_1.default,
    _a));
//# sourceMappingURL=component_output.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/component_output.js
// module id = P3Yx
// module chunks = 0 2 6 20